export * from '../src/composites/wui-visual-thumbnail/index.js';
//# sourceMappingURL=wui-visual-thumbnail.js.map